<template>
  <div class="noData" v-else>
    <v-svg h="50%">noData</v-svg>
    <div class="text">{{ $t('error_message') }}</div>
  </div>
</template>

<script>
  export default {
    name: 'NoData',
    /* eslint-disable camelcase */
    i18n: {
      messages: {
        fr: {
          error_message: 'Erreur dans le chargement de la saisie, veuillez recharger la page...'
        }
      }
    }
    /* eslint-enable camelcase */
  }
</script>

<style lang="scss" scoped>
  .noData {
    @include display-flex(center, center, column);

    .text {
      margin-top: 5rem;
      font: 20px $primary-font;
    }
  }
</style>
